import React from 'react'

function CreateSms() {
  return (
    <div>CreateSms</div>
  )
}

export default CreateSms